module.exports = __webpack_public_path__ + "img/zhuli-modal.735887de.png";